import React from 'react'
import { getIn, Field } from 'formik'
import { Form } from 'react-bootstrap'
import { FaRegTrashAlt } from 'react-icons/fa'
import { Variant } from '../../../../models/Item'
import styles from '../listingForm.module.css'

type Props = {
  variants: Variant[]
  handleChange: any
  handleBlur: any
  handleTouch: any
  handleError: any
  handleRemove: (index: number) => void
}

const TableVariants = ({
  variants,
  handleChange,
  handleBlur,
  handleTouch,
  handleError,
  handleRemove
}: Props) => {
  return (
    <>
      {variants.map((p, index) => {
        const variantPrice = `variants[${index}].price`
        const variantPriceTouched = getIn(handleTouch, variantPrice)
        const variantPriceError = getIn(handleError, variantPrice)
        const variantDescription = `variants[${index}].description`
        const variantDescriptionTouched = getIn(handleTouch, variantDescription)
        const variantDescriptionError = getIn(handleError, variantDescription)
        return (
          <tr key={index} data-testid="table-variants">
            <td>
              <Field
                name={variantPrice}
                as={Form.Control}
                type="number"
                min="0"
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={variantPriceTouched && !!variantPriceError}
              />
              <Form.Control.Feedback type="invalid">
                {variantPriceError}
              </Form.Control.Feedback>
            </td>
            <td>
              <Field
                name={variantDescription}
                as={Form.Control}
                type="text"
                min="0"
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={
                  variantDescriptionTouched && !!variantDescriptionError
                }
                placeholder="enter description"
              />
              <Form.Control.Feedback type="invalid">
                {variantDescriptionError}
              </Form.Control.Feedback>
            </td>

            <td>
              <FaRegTrashAlt
                className={styles.deleteListing}
                onClick={() => {
                  handleRemove(index)
                }}
              />
            </td>
          </tr>
        )
      })}
    </>
  )
}

export default TableVariants
